import { render, staticRenderFns } from "./CsLiquidacionIndex.vue?vue&type=template&id=8da12f8a"
import script from "./CsLiquidacionIndex.vue?vue&type=script&lang=js"
export * from "./CsLiquidacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports